import PropTypes from 'prop-types';
import { iconsList } from './glyphs';
import { TYPES } from './constants';

export const ICON_PROP_TYPES = {
  glyph: PropTypes.oneOf(iconsList),
  type: PropTypes.oneOf(Object.values(TYPES)),
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  strokeWidth: PropTypes.number,
  insideText: PropTypes.bool,
  withScaleFactor: PropTypes.bool,
};
